import "@rainbow-me/rainbowkit/styles.css";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { ConnectButton, RainbowKitProvider, getDefaultConfig } from "@rainbow-me/rainbowkit";
import { WagmiProvider, http } from "wagmi";
import { rainbowWeb3AuthConnector, web3AuthInstance } from "./RainbowWeb3authConnector";

import { rainbowWallet, metaMaskWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { mainnet } from "wagmi/chains";

import { Header } from './components/Header';
import { Footer } from './components/Footer';


import { Web3AuthProvider } from './Web3AuthContext';
import { Home } from './Home';

const config = getDefaultConfig({
  appName: 'Cryptocademia Wallet',
  projectId: 'e055b475385319d242231c7b3c56a1cb',
  chains: [mainnet],
  transports: {
    [mainnet.id]: http()
  },
  wallets: [{
    groupName: 'Recommended',
    wallets: [
      rainbowWallet,
      rainbowWeb3AuthConnector,
      metaMaskWallet,
      walletConnectWallet
    ],
  }],
});

const queryClient = new QueryClient()

export default function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
        <Web3AuthProvider web3AuthInstance={web3AuthInstance}>
          <Header />
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
            <Toaster position="top-center" toastOptions={{ style: { border: '1px solid black', padding: '16px', color: '#141414', }, iconTheme: { primary: '#141414', secondary: '#FFF', } }} reverseOrder={false} />
          </Router>
          <Footer />
          </Web3AuthProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}